import { action } from 'satcheljs';
export default action('ON_SET_START_TIME', function (dateTime) {
    return {
        dateTime: dateTime,
    };
});
//# sourceMappingURL=setStartTime.js.map